import { useGraphqlQuery } from "@harea/component";
import { TTimeOffsResponse } from "@harea/component";
import { TimeOffsQuery } from "queries/TimeOffsQuery";
import moment from "moment";

export const useTimeOffOverlapQuery = (data: any, options?: { enabled?: boolean, transformErrorMessage?: (e?: any) => string | undefined }) => {
    const employeeId = data?.employee?.id ?? data?.employee;
    const dateBegin = data?.dateBegin;
    const dateEnd = data?.dateEnd;

    const filters = {
        employee: { id: employeeId },
        dateBegin_infOrEquals: dateEnd,
        dateEnd_supOrEquals: dateBegin,
        status_notAmong: ["REFUSED", "REVOKED", "CANCELED", "CLOSED"],
        ...(data?.id ? { id_not: data?.id } : {}),
    };

    return useGraphqlQuery<TimeOffsQuery, TTimeOffsResponse>(
        new TimeOffsQuery({ data: filters }),
        {
            enabled: !!options?.enabled && !!employeeId && !!dateBegin && !!dateEnd && moment(dateBegin).isValid() && moment(dateEnd).isValid(),
            transformErrorMessage: options?.transformErrorMessage,
        }
    );
};
